/*
 * @Author: wuchenge
 * @Date:   2022-04-06 18:26:47
 * @Last Modified by:   无尘阁
 * @Last Modified time: 2022-04-06 20:55:40
 */

import { fromJS } from "immutable";

import { http } from "utils/http";
import * as types from "./types";

const changeDetail = (data) => {
  return {
    type: types.DETAIL_CHANGE_DETAIL,
    data: fromJS(data),
  };
};

export const getDetail = (id) => {
  return (dispatch) => {
    http("/detail/" + id)
      .then((res) => {
        dispatch(changeDetail(res));
      })
      .catch((err) => console.log(err));
  };
};
